var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppliedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.453,
    height: 35.075,
    viewBox: "0 0 23.453 35.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".class{fill:\"current\";}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.506 0.512)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "class",
    d: "M292,318.619a87.057,87.057,0,0,1-2.9-13.4c-.4-2.7,1.551-4.251,4.184-3.544,1.325-1.643,2.177-1.919,4.16-1.32.973-1.706,2.5-1.59,4.189-1.135,0-2.62-.007-5.147,0-7.743-.128-3.72,5.927-3.694,5.77.037-.019,4.471-.108,8.944.031,13.415a.956.956,0,0,0,.417.715c5.606,2.891-2.453,10.517-5.1,12.98Z",
    transform: "translate(-289.047 -284.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "class",
    d: "M349.362,263.3c5.534.775,8.14,7.75,4.14,11.792-.354.357-.748.645-1.2.309-.562-.416-.335-.876.075-1.3a5.352,5.352,0,0,0,1.567-3.957c-1.258-10.188-15.593-3.974-9.3,3.933.4.419.8.855.252,1.367-.571.529-1,.024-1.356-.377C339.015,270.452,343.059,262.642,349.362,263.3Z",
    transform: "translate(-333.055 -263.261)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedIcon);
export default __webpack_public_path__ + "static/media/AppliedIcon.75c7065c.svg";
export { ForwardRef as ReactComponent };